import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuard } from 'shared/guards/auth.guard';
import { CustomMaterialModule } from '@sk/custom-material';
import { AngularFireModule } from '@angular/fire';
import { environment } from 'environments/environment';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { HttpClientModule } from '@angular/common/http';
import { NgxMaskModule } from 'ngx-mask';
import { SignOutGuard } from 'shared/guards/sign-out.guard';
import { UiSpinnerModule } from 'shared/ui-services/ui-spinner/ui-spinner.module';
import { MAT_DATE_LOCALE } from '@angular/material/core';

import { QueryParamsGuard } from 'shared/guards/overview-guard.service';
import { InvoiceDisplayModule } from 'components/invoice-display/invoice-display.module';
import { httpInterceptorProviders } from 'shared/http-interceptors';
import { UiLoaderModule } from 'shared/ui-services/ui-loader/ui-loader.module';
import { AngularFirePerformanceModule } from '@angular/fire/performance';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NxModule } from '@nrwl/angular';
import { StateModule } from './+state/state.module';
import * as moment from 'moment';
import 'moment/locale/nl'; // Import Dutch locale
import 'moment/locale/es'; // Import Spanish locale

const languageMapping = {
  'en-US': 'en',
  'es-US': 'es',
  'nl-NL': 'nl',
};

console.log('env.language ' + environment.language);
const mappedLanguage = languageMapping[environment.language] || 'nl';
moment.locale(mappedLanguage);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NxModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase), // imports firebase/app needed for everything
    AngularFirestoreModule, // imports firebase/firestore, only needed for database features
    AngularFireAuthModule, // imports firebase/auth, only needed for auth features,
    AngularFireStorageModule, // imports firebase/storage only needed for storage features
    AngularFirePerformanceModule,
    AngularFireAnalyticsModule,
    // AngularFireMessagingModule, // imports firebase/messaging only needed for messaging features
    AppRoutingModule,
    CustomMaterialModule,
    HttpClientModule,
    UiSpinnerModule,
    UiLoaderModule,
    InvoiceDisplayModule,
    NgxMaskModule.forRoot(),
    StoreModule.forRoot(
      {},
      {
        metaReducers: !environment.production ? [] : [],
        runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: true
        }
      }
    ),
    EffectsModule.forRoot([]),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    StateModule
  ],
  providers: [
    AuthGuard,
    SignOutGuard,
    QueryParamsGuard,
    httpInterceptorProviders,
    { provide: LOCALE_ID, useValue: environment.language },
    { provide: MAT_DATE_LOCALE, useValue: environment.language }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
